// extracted by mini-css-extract-plugin
export var active = "footer-module--active--7f5b9";
export var bottom = "footer-module--bottom--d6602";
export var bottomLinks = "footer-module--bottomLinks--24247";
export var bottomLinksBlock = "footer-module--bottomLinksBlock--b5fed";
export var contact = "footer-module--contact--3d89a";
export var cookies = "footer-module--cookies--bad6d";
export var copy = "footer-module--copy--a780a";
export var copyright = "footer-module--copyright--e54b7";
export var footerMenu = "footer-module--footerMenu--0b027";
export var footerMenuBlock = "footer-module--footerMenuBlock--d7bce";
export var heading = "footer-module--heading--34ef3";
export var newsletter = "footer-module--newsletter--cff78";
export var root = "footer-module--root--428e0";
export var row = "footer-module--row--2ec79";
export var socialMedia = "footer-module--socialMedia--bb5c6";
export var top = "footer-module--top--00449";